<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main" >
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
              <el-form-item prop="name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="50"
                />
              </el-form-item>

              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.tipo_distribuidor')}}</label>
              <el-form-item prop="tipoDistribuidor">
                  <base-el-select class="w-full" :options="tiposDistribuidor" v-model="form.tipoDistribuidor.value" clearable filterable />
              </el-form-item>

              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.tipo_provisionamiento')}}</label>
              <el-form-item prop="tipoProvisionamiento">
                  <base-el-select class="w-full" :options="tiposProvisionamiento" v-model="form.tipoProvisionamiento.value" clearable filterable />
              </el-form-item>

              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.permite_wizard')}}</label>
              <el-form-item prop="permiteWizard">
                <base-el-select class="w-full" :options="values" v-model="form.permiteWizard.value" clearable filterable 
                  :placeholder="$t('clients.permite_wizard_yes_no')" />
              </el-form-item>

              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.integracion_zoho')}}</label>
              <el-form-item prop="IntegracionZoho">
                <base-el-select class="w-full" :options="values" v-model="form.IntegracionZoho.value" clearable filterable 
                  :placeholder="$t('clients.integracion_zoho_yes_no')" />
              </el-form-item>

            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'distributors',
      isOpen: this.panelOpen,
      links: [],
      form: {
        name: { label: i18n.t('app.name'), value: '' },
        tipoDistribuidor: { label: i18n.t('distributors.tipo_distribuidor'), value: '' },
        tipoProvisionamiento: { label: i18n.t('distributors.tipo_provisionamiento'), value: '' },
        permiteWizard: { label: i18n.t('clients.permite_wizard'), value: '' },
        IntegracionZoho: { label: i18n.t('clients.integracion_zoho'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposDistribuidor: function () {
      return this.$store.getters['config/TIPOS_DISTRIBUIDOR']
    },
    tiposProvisionamiento: function () {
      return this.$store.getters['config/TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.tipoDistribuidor.value = _temp.tipoDistribuidor !== undefined && _temp.tipoDistribuidor.value !== '' ? _temp.tipoDistribuidor.value : ''
        this.form.tipoProvisionamiento.value = _temp.tipoProvisionamiento !== undefined && _temp.tipoProvisionamiento.value !== '' ? _temp.tipoProvisionamiento.value : ''
        this.form.permiteWizard.value = _temp.permiteWizard !== undefined && _temp.permiteWizard.value !== '' ? _temp.permiteWizard.value : ''
        this.form.IntegracionZoho.value = _temp.IntegracionZoho !== undefined && _temp.IntegracionZoho.value !== '' ? _temp.IntegracionZoho.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        name: { label: i18n.t('app.name'), value: '' },
        tipoDistribuidor: { label: i18n.t('distributors.tipo_distribuidor'), value: '' },
        tipoProvisionamiento: { label: i18n.t('distributors.tipo_provisionamiento'), value: '' },
        permiteWizard: { label: i18n.t('clients.permite_wizard'), value: '' },
        IntegracionZoho: { label: i18n.t('clients.integracion_zoho'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
  }
}
</script>

<style lang="scss" scoped></style>
